import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

export type PageLayoutVariant =
  | "standard"
  | "fullHeight"
  | "constrained"
  | "edgeToEdge";

export interface PageLayoutProps {
  children: React.ReactNode;
  variant?: PageLayoutVariant;
  maxWidth?: number | string;
  sx?: SxProps<Theme>;
}

const toSxArray = (sx?: SxProps<Theme>) =>
  Array.isArray(sx) ? sx : sx ? [sx] : [];

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  variant = "standard",
  maxWidth = 1440,
  sx,
}) => {
  if (variant === "edgeToEdge") {
    return (
      <Box
        sx={[
          {
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
          },
          ...toSxArray(sx),
        ]}
      >
        {children}
      </Box>
    );
  }

  const isFullHeight = variant === "fullHeight";
  const isConstrained = variant === "constrained";

  return (
    <Box
      sx={[
        {
          flex: isFullHeight ? 1 : undefined,
          minWidth: 0,
          minHeight: isFullHeight ? 0 : undefined,
          width: "100%",
          maxWidth: isConstrained ? maxWidth : "100%",
          mx: isConstrained ? "auto" : undefined,
          px: 3,
          py: 3,
          display: isFullHeight ? "flex" : undefined,
          flexDirection: isFullHeight ? "column" : undefined,
          height: isFullHeight ? "100vh" : undefined,
          overflow: isFullHeight ? "hidden" : undefined,
          overflowX: "hidden",
        },
        ...toSxArray(sx),
      ]}
    >
      {children}
    </Box>
  );
};

export default PageLayout;
